import React from 'react';
import './style.css';

const ContainerFees = ({ feesData }) => {
  return (
    <div className="container_fees">
      <p className="text"></p>
      {feesData.map(({ name, formula, style, value }, index) => (
        <div>
          <p
            style={{
              fontWeight: index === feesData.length - 1 && 'bold',
            }}
            className="text"
          >
            {name}: {formula}
            {value}€
          </p>
        </div>
      ))}
    </div>
  );
};

export default ContainerFees;
